import styled from 'styled-components';
import * as S from '../../styles';

export const Container = styled(S.BlockBase)`
  flex: 0 0 20px;
  width: 20px;
  position: sticky;
  left: 0;
  z-index: 12;
`;

export const ColTimeLabel = styled(S.BlockBase)`
  position: relative;
  padding-top: 4px;
  top: -12px;
  color: ${({ theme }) => theme.palette.grayscale500};
  ${({ theme }) => theme.typography('$caption_02')};
  background-color: var(--color-background);
`;
